module.exports = __webpack_public_path__ + "img/es-pc-step-4.ee80e8b3.png";